import { formatFirestoreDate } from "../../../Pages/CloudAnalytics/utilities";
import { type GCPTableUpdate, type TransformedGCPTableUpdate } from "./types";

export const formatRow = (row: GCPTableUpdate): TransformedGCPTableUpdate => ({
  ...row,
  transform: {
    createdAt: formatFirestoreDate(row.createdAt),
  },
});
